import { Field } from '../../form/decorators/Field';
import EmbeddedForm from '../../form/EmbeddedForm';
import { TicketTier } from '../../types/api';

export class TicketTierForm extends EmbeddedForm<TicketTier> {
  @Field({ static: true })
  public id?: string;

  @Field({ static: true })
  public name: string = '';

  @Field({ static: true })
  public description?: string | null;

  @Field({ static: true })
  public price: number = 0;

  @Field({ static: true })
  public limit: number = 0;

  constructor(tier?: TicketTier) {
    super(tier);
    if (tier) {
      this.id = tier.id;
      this.name = tier.name;
      this.description = tier.description;
      this.price = tier.price;
      this.limit = tier.limit;
    }
  }
}
